import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const PROCESS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.PROCESS,
  false
);

export const processApi = {
  processForm: () => apiClient.get(`${PROCESS_BASE}/form`),

  editProcessForm: Id =>
    apiClient.get(`${PROCESS_BASE}/form?is_edit=true&process_id=${Id}`),

  createProcess: combinedData =>
    apiClient.post(`${PROCESS_BASE}`, combinedData),

  updateProcess: (process_id, combinedData) =>
    apiClient.put(`${PROCESS_BASE}/${process_id}`, combinedData)
};
